<template>
  <section class="fa-table recognition-table py2 sans border-top mx-auto" :class="{ 'border-top': showTitle }">
    <h3 class="sm-hide md-hide lg-hide mb3 red" v-if="showTitle">Recognition</h3>
    <div class="row clearfix mxn2" :class="{ 'px2': !showTitle }">
      <div class="col xs-hide sm-col-4 px2" v-if="showTitle">Recognition</div>
      <div class="col" :class="{ 'col col-12 sm-col-8 px2': showTitle, 'col-12': !showTitle }">
        <div v-for="(item, index) in contentSorted"
          class="hover-red row clearfix mb2 mxn2" :key="index">
          <a :href="item.link" target="_blank">
            <div class="col tabular px2" :class="{ 'col-6': showTitle, 'col-4': !showTitle }">{{ item.date }}</div>
            <div class="col px2" :class="{ 'col-6': showTitle, 'col-8': !showTitle }">
                <em>{{ item.title || item.post_title }}</em>
                <!-- <div><img :src="item.image.sizes.medium" /></div> -->
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import dayjs from 'dayjs'
import { formatDate } from '@/utils'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

export default {

  name: 'RecognitionTable',

  data () {
    return {

    }
  },

  methods: {
    formatDate
  },

  props: ['content', 'showTitle'],

  computed: {
    contentSorted () {
      if (this.content) {
        let sorted = [...this.content]

        sorted.sort((a, b) => {
          return dayjs(b.date, "DD.MM.YYYY").unix() - dayjs(a.date, "DD.MM.YYYY").unix()
        })

        return sorted
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .recognition-table {
    max-width: var(--max-width-med);
    line-height: var(--line-height-reader);

    a:hover {
      color: var(--red);
    }
  }
</style>
